import { RoleId, Action } from '@/enum'

interface ActionMassage {
  normal: string;
  will: string;
  tempted: string;
  stolen: string;
}

type RoleMessage = {
  [roleId in RoleId]: {
    action: {
      [Action.targetSelect]: ActionMassage;
      [Action.nothing]: ActionMassage;
      [Action.armor]: ActionMassage;
      [Action.detonate]: ActionMassage;
    };
    actionResult: {
      success: string;
      failed: string;
    };
  }
}

export const ROLE_MESSAGE: RoleMessage = {
  [RoleId.people]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.nobleman]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.believers]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.police]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を取り調べた',
        will: '{{targetName}}を取り調べるつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '休暇を過ごした',
        will: '',
        tempted: '{{targetedName}}と楽しい休暇を過ごした',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}はマフィア陣営だ',
      failed: '{{targetName}}はマフィア陣営ではなかった'
    }
  },
  [RoleId.investigator]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を捜査した',
        will: '{{targetName}}を捜査するつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '休暇を過ごした',
        will: '',
        tempted: '{{targetedName}}と楽しい休暇を過ごした',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}は武器を所持していた',
      failed: '{{targetName}}は武器を所持していなかった'
    }
  },
  [RoleId.doctor]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を診た',
        will: '{{targetName}}を診るつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に医療道具を盗まれて何もできなかった'
      },
      [Action.nothing]: {
        normal: '休暇を過ごした',
        will: '',
        tempted: '{{targetedName}}と楽しい休暇を過ごした',
        stolen: '{{targetedName}}に医療道具を盗まれていた'
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.dancer]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を誘惑した',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '誰も誘惑しなかった',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.sniper]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を狙撃した',
        will: '{{targetName}}を狙撃するつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に銃を盗まれていて何もできなかった',
      },
      [Action.nothing]: {
        normal: '誰も撃たなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に銃を盗まれていた'
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}を殺害した',
      failed: '{{targetName}}は殺せなかった'
    }
  },
  [RoleId.survivor]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '防弾チョッキを温存した',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: ''
      },
      [Action.armor]: {
        normal: '防弾チョッキを使った',
        will: '防弾チョッキを着るつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.cinderellaGirl]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.mafia]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}をターゲットに提案',
        will: '{{targetName}}を襲撃しようと思ったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に獲物を盗まれていて何もできなかった'
      },
      [Action.nothing]: {
        normal: '誰もターゲットを選ばなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に獲物を盗まれていた'
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}を殺害した',
      failed: '{{targetName}}は殺せなかった'
    }
  },
  [RoleId.godfather]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.godfatherAndMafia]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を襲撃した',
        will: '{{targetName}}を襲撃しようと思ったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に獲物を盗まれていて何もできなかった'  
      },
      [Action.nothing]: {
        normal: '誰も襲撃しなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に獲物を盗まれていた'
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}を殺害した',
      failed: '{{targetName}}は殺せなかった'
    }
  },
  [RoleId.daughter]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.prostitute]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を誘惑した',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '誰も誘惑しなかった',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.traitor]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.trickster]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}をペテンにかけた',
        will: '{{targetName}}をペテンにかけるつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '誰もペテンにかけなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていた',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.bomber]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}に爆弾を設置した',
        will: '{{targetName}}に爆弾を設置するつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に爆弾を盗まれていて何もできなかった'
      },
      [Action.nothing]: {
        normal: '起爆も爆弾の設置も行わなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていた',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '爆弾を起爆した',
        will: '爆弾を起爆するつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}に起爆装置を盗まれていて何もできなかった'
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.killer]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}を襲った',
        will: '{{targetName}}を襲うつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: '{{targetedName}}にナイフを盗まれていて何もできなかった'
      },
      [Action.nothing]: {
        normal: '誰も襲わなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていた',
        stolen: '{{targetedName}}にナイフを盗まれていた'
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}を殺害した',
      failed: '{{targetName}}は殺せなかった'
    }
  },
  [RoleId.boy]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.assassin]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
  [RoleId.pickpocket]: {
    action: {
      [Action.targetSelect]: {
        normal: '{{targetName}}に接触した',
        will: '{{targetName}}に盗みを働くつもりだったが',
        tempted: '{{targetedName}}と楽しい夜を過ごしていて何もできなかった',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '盗みを働かなかった',
        will: '',
        tempted: '{{targetedName}}と楽しい夜を過ごしていた',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '{{targetName}}から盗むことに成功した',
      failed: '{{targetName}}は盗めるものを持っていなかった'
    }
  },
  [RoleId.crab]: {
    action: {
      [Action.targetSelect]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.nothing]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.armor]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      },
      [Action.detonate]: {
        normal: '',
        will: '',
        tempted: '',
        stolen: ''
      }  
    },
    actionResult: {
      success: '',
      failed: ''
    }
  },
}